import { IconTestPipe, IconUsers, IconSettings, IconSpeakerphone, IconChartBar } from "@tabler/icons-react";

export const links = [
    { link: "/batches/", label: "Batches", icon: IconTestPipe },
    { link: "/users/", label: "Users", icon: IconUsers },
    // { link: "/statistics/", label: "Statistics", icon: IconChartBar },
    { link: "/reports/", label: "Reports", icon: IconSpeakerphone },
    { link: "/organization-settings/", label: "Settings", icon: IconSettings },
];
